/**
 *
 */
export const state = () => ({
    isDebugBoxVisible: false,
    debugStatusLifts: '(Not set)',
    debugStatusTracks: '(Not set)',
});

export const mutations = {
    setIsDebugBoxVisible(state, flag) {
        state.isDebugBoxVisible = flag;
    },
    setDebugStatusLifts(state, value) {
        state.debugStatusLifts = value;
    },
    setDebugStatusTracks(state, value) {
        state.debugStatusTracks = value;
    },
};
